import React from "react";
import { Box, Typography, Button, Grid, TextField, Paper, Rating } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import detailsPageBanner from '../assets/images/details-page-banner.jpg';
import StudentsHiredBySection from "./StudentsHiredBySection";
import CourseCurriculumDetails from "./CourseDetails/CourseCurriculumDetails";

// Dummy course data (Replace this with API data or a state)
const courses = [
    {
        id: "azure-data-engineering-training",
        title: "Azure Data Engineering Training",
        rating: 4.5,
        reviews: "1k",
        description: "This comprehensive training is designed to enhance your skills in Azure Data Engineering, helping you advance your career. Throughout the course, you'll work on real-world projects and gain hands-on experience in Azure Data Engineering. We start from the basics, so no prior knowledge is required.",
        batch: "21st March 2025",
        fees: "₹15,000 – ₹25,000",
        curriculum: [
            {
                title: "1. Introduction to Azure Data Engineering",
                topics: [
                    "Overview of Data Engineering",
                    "Role of an Azure Data Engineer",
                    "Azure Data Platform Services Overview",
                ],
            },
            {
                title: "2. Azure Storage Solutions",
                topics: [
                    "Azure Storage Account",
                    "Azure Blob Storage",
                    "Azure Data Lake Storage Gen2",
                    "Azure Files and Table Storage",
                    "Securing and Managing Storage"
                ],
            },
            {
                title: "3. Azure Data Processing Technologies",
                topics: [
                    "Azure Synapse Analytics (SQL Data Warehouse)",
                    "Azure Data Factory (ETL & Orchestration)",
                    "Azure Databricks (Big Data & AI)",
                    "Azure Stream Analytics (Real-time Data Processing)",
                ],
            },
            {
                title: "4. Data Integration and Transformation",
                topics: [
                    "Data Ingestion with Azure Data Factory",
                    "Data Transformation with Mapping Data Flows",
                    "Integrating Data from Various Sources",
                    "Monitoring and Troubleshooting Pipelines",
                ],
            },
            {
                title: "5. Azure SQL and NoSQL Databases",
                topics: [
                    "Azure SQL Database & Managed Instances",
                    "Azure Cosmos DB (NoSQL Database)",
                    "Azure PostgreSQL & MySQL",
                    "Choosing the Right Database Solution",
                ],
            },
            {
                title: "6. Data Security & Compliance",
                topics: [
                    "Role-Based Access Control (RBAC)",
                    "Encryption & Network Security",
                    "Compliance and Governance in Azure",
                    "Auditing and Monitoring Data",
                ],
            },
            {
                title: "7. Implementing Data Solutions with Azure Synapse",
                topics: [
                    "Data Warehousing Concepts",
                    "Serverless vs. Dedicated Pools",
                    "Performance Tuning in Azure Synapse",
                ],
            },
            {
                title: "8. Real-time Data Processing",
                topics: [
                    "Event Hub & IoT Hub",
                    "Stream Analytics & Real-Time Dashboards",
                    "Data Visualization with Power BI",
                ],
            },
            {
                title: "9. Data Governance and Monitoring",
                topics: [
                    "Azure Purview for Data Governance",
                    "Monitoring Pipelines with Azure Monitor",
                    "Cost Optimization Strategies",
                ],
            },
            {
                title: "10. Hands-on Labs & Capstone Project",
                topics: [
                    "Building an End-to-End Data Pipeline",
                    "Implementing ETL with Azure Data Factory",
                    "Real-time Streaming with Event Hub & Stream Analytics",
                    "Data Visualization with Power BI"
                ],
            },
        ],
    },
    {
        id: "gcp-professional-certification-training",
        title: "GCP Data Engineering Training",
        rating: 4.8,
        reviews: "1.8k",
        description: "This comprehensive training is designed to enhance your skills in GCP Data Engineering, helping you advance your career. Throughout the course, you'll work on real-world projects and gain hands-on experience in GCP Data Engineering. We start from the basics, so no prior knowledge is required.",
        batch: "14th March 2025",
        fees: "₹20,000",
        curriculum: [
            {
                title: "1. Introduction to GCP Data Engineering",
                topics: [
                    "Overview of Data Engineering in GCP",
                    "Role of a GCP Data Engineer",
                    "Introduction to Google Cloud Services",
                ],
            },
            {
                title: "2. GCP Storage & Data Lake Solutions",
                topics: [
                    "Cloud Storage (Object Storage)",
                    "Cloud Datastore & Firestore (NoSQL Databases)",
                    "Bigtable (Wide-column Database)",
                    "Google Cloud Data Lake Architecture",
                ],
            },
            {
                title: "3. Data Processing & ETL Pipelines",
                topics: [
                    "Cloud Dataflow (Batch & Streaming Data Processing)",
                    "Apache Beam for Data Pipelines",
                    "Cloud Composer (Managed Apache Airflow)",
                    "Data Ingestion with Cloud Pub/Sub",
                ],
            },
            {
                title: "4. Google BigQuery - Data Warehouse",
                topics: [
                    "Introduction to BigQuery",
                    "BigQuery Architecture & SQL Queries",
                    "Partitioning & Clustering for Performance Optimization",
                    "Data Security & Access Control in BigQuery",
                ],
            },
            {
                title: "5. NoSQL & Relational Databases on GCP",
                topics: [
                    "Cloud SQL (Managed MySQL & PostgreSQL)",
                    "Cloud Spanner (Scalable Relational Database)",
                    "Cloud Firestore (Flexible NoSQL Database)",
                    "Choosing the Right Database for Workloads",
                ],
            },
            {
                title: "6. Real-time Data Streaming & Analytics",
                topics: [
                    "Cloud Pub/Sub (Messaging & Event Streaming)",
                    "Cloud Dataflow for Streaming Analytics",
                    "Real-time Dashboards with BigQuery & Looker Studio",
                    "IoT Data Processing in GCP",
                ],
            },
            {
                title: "7. Data Governance, Security & Compliance",
                topics: [
                    "Identity and Access Management (IAM)",
                    "Data Encryption & Security Best Practices",
                    "Data Governance with Dataplex",
                    "Auditing & Monitoring Data Pipelines"
                ],
            },
            {
                title: "8. Machine Learning & AI on GCP",
                topics: [
                    "AI & ML Integration with BigQuery ML",
                    "AutoML for Data Engineers",
                    "Training & Deploying ML Models with Vertex AI",
                    "Data Preparation for Machine Learning"
                ],
            },
            {
                title: "9. Hands-on Labs & Capstone Project",
                topics: [
                    "Building a Scalable ETL Pipeline in GCP",
                    "Real-time Data Processing with Pub/Sub & Dataflow",
                    "Data Analytics with BigQuery & Looker Studio",
                    "Implementing a Data Lakehouse Solution"
                ],
            },
        ],
    },
    {
        id: "aws-data-engineering-training",
        title: "AWS Data Engineering Training",
        rating: 4.9,
        reviews: "5k",
        description: "This comprehensive training is designed to enhance your skills in AWS Data Engineering, helping you advance your career. Throughout the course, you'll work on real-world projects and gain hands-on experience in AWS Data Engineering. We start from the basics, so no prior knowledge is required.",
        batch: "20th Feb 2025",
        fees: "₹15,000",
        curriculum: [
            {
                title: "1. Introduction to AWS Data Engineering",
                topics: [
                    "Overview of Data Engineering on AWS",
                    "Role of an AWS Data Engineer",
                    "AWS Data Analytics Services Overview",
                ],
            },
            {
                title: "2. AWS Storage & Data Lake Solutions",
                topics: [
                    "Amazon S3 (Simple Storage Service)",
                    "AWS Glue Data Catalog",
                    "AWS Lake Formation",
                    "Data Partitioning & Lifecycle Management",
                ],
            },
            {
                title: "3. ETL & Data Processing Pipelines",
                topics: [
                    "AWS Glue (Serverless ETL)",
                    "AWS Data Pipeline",
                    "Amazon EMR (Big Data Processing with Spark & Hadoop)",
                    "Apache Airflow with AWS Managed Workflows",
                ],
            },
            {
                title: "4. AWS Data Warehousing - Amazon Redshift",
                topics: [
                    "Introduction to Amazon Redshift",
                    "Redshift Spectrum & Query Optimization",
                    "Data Loading & Unloading Strategies",
                    "Security & Performance Tuning in Redshift",
                ],
            },
            {
                title: "5. Databases for AWS Data Engineering",
                topics: [
                    "Amazon RDS (Managed SQL Databases)",
                    "Amazon DynamoDB (NoSQL Database)",
                    "Amazon Aurora (Relational Database with Auto-scaling)",
                    "Choosing the Right AWS Database",
                ],
            },
            {
                title: "6. Real-time Data Streaming & Analytics",
                topics: [
                    "Amazon Kinesis Data Streams & Firehose",
                    "AWS Lambda for Event-driven Processing",
                    "Streaming Data Analytics with Amazon MSK (Managed Kafka)",
                    "IoT Data Processing with AWS IoT Analytics",
                ],
            },
            {
                title: "7. Data Governance, Security & Compliance",
                topics: [
                    "AWS IAM (Identity & Access Management)",
                    "Data Encryption & Security Best Practices",
                    "AWS Lake Formation for Data Governance",
                    "Auditing & Monitoring Data Pipelines"
                ],
            },
            {
                title: "8. Machine Learning & AI Integration",
                topics: [
                    "Amazon SageMaker for Data Engineers",
                    "AWS Glue with Machine Learning for Data Transformation",
                    "AI-powered Analytics with AWS QuickSight",
                    "Automating ML Workflows on AWS"
                ],
            },
            {
                title: "9. Hands-on Labs & Capstone Project",
                topics: [
                    "Building an ETL Pipeline with AWS Glue",
                    "Real-time Streaming with Kinesis & Lambda",
                    "Data Warehousing with Redshift & QuickSight",
                    "Implementing an AWS Data Lakehouse Solution"
                ],
            },
        ],
    },
    {
        id: "snowflake-data-engineering-training",
        title: "Snowflake Data Engineering Training",
        rating: 5.0,
        reviews: "500",
        description: "This comprehensive training is designed to enhance your skills in Snowflake Data Engineering, helping you advance your career. Throughout the course, you'll work on real-world projects and gain hands-on experience in Snowflake Data Engineering. We start from the basics, so no prior knowledge is required.",
        batch: "20th Feb 2025",
        fees: "₹9,999 – ₹29,999",
        curriculum: [
            {
                title: "1. Introduction to Snowflake",
                topics: [
                    "Overview of Cloud Data Warehousing",
                    "Introduction to Snowflake Architecture",
                    "Snowflake Editions & Pricing Models",
                    "Key Features: Separation of Storage & Compute"
                ],
            },
            {
                title: "2. Setting Up & Configuring Snowflake",
                topics: [
                    "Creating & Managing Snowflake Accounts",
                    "Understanding Virtual Warehouses",
                    "Database & Schema Design in Snowflake",
                    "Role-Based Access Control (RBAC) & Security",
                ],
            },
            {
                title: "3. Snowflake Storage & Data Ingestion",
                topics: [
                    "Data Loading Methods (COPY, Snowpipe, Stages)",
                    "Working with Structured & Semi-Structured Data (JSON, Parquet, Avro)",
                    "External Tables & Integration with AWS, Azure, and GCP",
                    "Automating Data Ingestion with Snowpipe",
                ],
            },
            {
                title: "4. SQL & Query Optimization in Snowflake",
                topics: [
                    "Writing Efficient Queries in Snowflake",
                    "Performance Tuning & Query Profiling",
                    "Caching & Clustering Concepts",
                    "Materialized Views & Result Set Caching",
                ],
            },
            {
                title: "5. Snowflake Data Processing & Transformation",
                topics: [
                    "Working with Streams & Tasks for Data Pipelines",
                    "Using Stored Procedures & UDFs in Snowflake",
                    "Data Transformation with Snowpark & Python",
                    "Data Orchestration with dbt & Airflow",
                ],
            },
            {
                title: "6. Data Sharing & Collaboration",
                topics: [
                    "Secure Data Sharing Between Accounts",
                    "Snowflake Data Marketplace",
                    "Working with Snowflake Data Exchange",
                    "Multi-Cloud & Cross-Region Data Sharing",
                ],
            },
            {
                title: "7. Snowflake Security & Governance",
                topics: [
                    "Data Encryption & Compliance (GDPR, HIPAA, SOC)",
                    "Role-Based Access Control (RBAC) & Policies",
                    "Auditing & Monitoring with Snowflake Access History",
                    "Data Masking & Row-Level Security"
                ],
            },
            {
                title: "8. Real-time Data Processing in Snowflake",
                topics: [
                    "Integrating Snowflake with Kafka & Streams",
                    "Snowpipe for Continuous Data Ingestion",
                    "Real-time Analytics with Snowflake & BI Tools",
                    "Best Practices for Streaming Workloads"
                ],
            },
            {
                title: "9. Machine Learning & Advanced Analytics",
                topics: [
                    "Using Snowflake for AI & ML Workflows",
                    "Snowpark for Python & Data Science",
                    "Integration with ML Tools (Databricks, SageMaker)",
                    "Building Predictive Models on Snowflake"
                ],
            },
            {
                title: "10. Hands-on Labs & Capstone Project",
                topics: [
                    "End-to-End ETL Pipeline in Snowflake",
                    "Real-time Data Streaming & Processing",
                    "Implementing a Snowflake Data Lakehouse",
                    "Data Visualization with Looker & Power BI"
                ],
            },
        ],
    },
    {
        id: "full-stack-data-engineering-training",
        title: "Full stack Data Engineering Training",
        rating: 5.0,
        reviews: "500",
        description: "This comprehensive training is designed to enhance your skills in Full stack Data Engineering, helping you advance your career. Throughout the course, you'll work on real-world projects and gain hands-on experience in Full stack Data Engineering. We start from the basics, so no prior knowledge is required.",
        batch: "20th Feb 2025",
        fees: "34,999 - 59,999",
        curriculum: [
            {
                title: "1. Introduction to Full-Stack Data Engineering",
                topics: [
                    "What is Full-Stack Data Engineering?",
                    "Role & Responsibilities of a Data Engineer",
                    "Overview of Data Engineering Ecosystem",
                    "Comparison of AWS, Azure, GCP & Snowflake"
                ],
            },
            {
                title: "2. Data Storage & Databases",
                topics: [
                    "Cloud Storage (AWS S3, Azure Data Lake, GCP Cloud Storage)",
                    "Relational Databases (PostgreSQL, MySQL, Amazon RDS, Azure SQL)",
                    "NoSQL Databases (MongoDB, DynamoDB, Cassandra)",
                    "Data Lakehouse Concept (Delta Lake, Iceberg, Hudi)",
                ],
            },
            {
                title: "3. ETL & Data Pipelines",
                topics: [
                    "Introduction to ETL vs. ELT",
                    "Data Ingestion Tools (AWS Glue, Azure Data Factory, Google Dataflow)",
                    "Apache NiFi, Apache Kafka for Streaming Ingestion",
                    "Batch Processing with Apache Spark & Hadoop",
                ],
            },
            {
                title: "4. Data Processing with Apache Spark",
                topics: [
                    "Introduction to Apache Spark Architecture",
                    "Spark Core, Spark SQL & Spark Streaming",
                    "Using PySpark for Data Processing",
                    "Optimizing Spark Jobs & Performance Tuning",
                ],
            },
            {
                title: "5. Data Warehousing & Analytics",
                topics: [
                    "Amazon Redshift, Google BigQuery, Azure Synapse",
                    "Snowflake Data Warehouse",
                    "Query Optimization & Performance Tuning",
                    "Data Modeling & Partitioning Strategies",
                ],
            },
            {
                title: "6. Real-Time Data Processing",
                topics: [
                    "Kafka & Spark Streaming for Real-time Data Processing",
                    "AWS Kinesis, Google Pub/Sub, Azure Event Hubs",
                    "Building Real-time Dashboards with Power BI & Looker Studio",
                ],
            },
            {
                title: "7. Data Governance & Security",
                topics: [
                    "Role-Based Access Control (RBAC) & IAM",
                    "Data Encryption & Compliance (GDPR, HIPAA)",
                    "Data Lineage & Auditing with Apache Atlas & Databricks Unity Catalog",
                ],
            },
            {
                title: "8. Machine Learning for Data Engineers",
                topics: [
                    "ML Pipelines with MLflow & Vertex AI",
                    "BigQuery ML, AWS SageMaker, Azure Machine Learning",
                    "Feature Engineering & Model Deployment",
                ],
            },
            {
                title: "9. DevOps & CI/CD for Data Pipelines",
                topics: [
                    "Infrastructure as Code (Terraform, CloudFormation)",
                    "CI/CD for Data Pipelines with Jenkins & GitHub Actions",
                    "Monitoring & Logging with Prometheus & Grafana",
                ],
            },
            {
                title: "10. Hands-on Labs & Capstone Project",
                topics: [
                    "Building an End-to-End Data Pipeline (Ingestion → Processing → Analytics)",
                    "Real-time Streaming with Kafka & Spark",
                    "Implementing a Cloud Data Lakehouse",
                    "Data Visualization & Reporting"
                ],
            },
        ],
    },
    {
        id: "big-data-engineering-training",
        title: "Big Data Engineering Training",
        rating: 5.0,
        reviews: "500",
        description: "This comprehensive training is designed to enhance your skills in Big Data Engineering, helping you advance your career. Throughout the course, you'll work on real-world projects and gain hands-on experience in Big Data Engineering. We start from the basics, so no prior knowledge is required.",
        batch: "20th Feb 2025",
        fees: "9,999 - 29,999",
        curriculum: [
            {
                title: "1. Introduction to Big Data Engineering",
                topics: [
                    "What is Big Data? Characteristics & Challenges",
                    "Role of a Big Data Engineer",
                    "Overview of Big Data Ecosystem",
                    "Hadoop vs. Spark vs. Cloud Data Engineering"
                ],
            },
            {
                title: "2. Distributed Storage & Big Data Frameworks",
                topics: [
                    "Introduction to Hadoop Ecosystem",
                    "HDFS (Hadoop Distributed File System)",
                    "Apache Hive & HBase (NoSQL Database)",
                    "Apache Impala & Presto for SQL-based Big Data",
                ],
            },
            {
                title: "3. Data Ingestion & ETL Pipelines",
                topics: [
                    "Batch Data Ingestion with Apache Sqoop & Flume",
                    "Real-time Data Ingestion with Apache Kafka",
                    "Data Integration with Apache Nifi & Airflow",
                    "ETL Pipelines with Apache Spark & Hadoop",
                ],
            },
            {
                title: "4. Data Processing with Apache Spark",
                topics: [
                    "Spark Architecture & Execution Model",
                    "Spark Core, Spark SQL & DataFrames",
                    "Spark Streaming for Real-time Data Processing",
                    "Performance Optimization in Spark (Partitioning, Caching, Shuffling)",
                ],
            },
            {
                title: "5. Cloud Big Data Platforms",
                topics: [
                    "AWS Big Data Services (S3, Glue, EMR, Redshift, Kinesis)",
                    "Azure Big Data Services (Data Lake, Synapse, Event Hub)",
                    "Google Cloud Big Data Services (BigQuery, Dataflow, Pub/Sub)",
                    "Snowflake for Big Data Processing",
                ],
            },
            {
                title: "6. Real-Time Big Data Analytics",
                topics: [
                    "Apache Kafka & Apache Flink for Stream Processing",
                    "Amazon Kinesis & Azure Event Hub for Real-time Data",
                    "Real-time Dashboards with Power BI, Looker Studio",
                    "IoT Data Processing for Big Data"
                ],
            },
            {
                title: "7. Big Data Warehousing & Lakehouse Architectures",
                topics: [
                    "Data Warehouse vs. Data Lake vs. Lakehouse",
                    "Snowflake, Databricks Delta Lake, Apache Iceberg",
                    "Managing Large-Scale Data in Cloud Warehouses",
                    "Query Optimization & Performance Tuning"
                ],
            },
            {
                title: "8. Data Governance, Security & Compliance",
                topics: [
                    "Role-Based Access Control (RBAC) & IAM",
                    "Data Encryption, Masking & Anonymization",
                    "GDPR, HIPAA & Compliance Best Practices",
                    "Data Lineage & Cataloging with Apache Atlas"
                ],
            },
            {
                title: "9. Big Data Machine Learning & AI",
                topics: [
                    "ML & AI Workflows with Spark MLlib",
                    "BigQuery ML, AWS SageMaker, Azure ML",
                    "Automating ML Pipelines with MLflow & Kubeflow",
                    "Real-time Predictive Analytics"
                ],
            },
            {
                title: "10. Hands-on Labs & Capstone Project",
                topics: [
                    "Building an End-to-End Big Data Pipeline",
                    "Real-time Streaming with Kafka & Spark Streaming",
                    "Implementing a Cloud-based Data Lakehouse",
                    "Data Visualization & Reporting"
                ],
            },
        ],
    },
];

const CourseDetailsBanner = () => {
    const { id } = useParams(); // Get course ID from URL
    const navigate = useNavigate();
    const course = courses.find((c) => c.id === id); // Find the course based on ID

    if (!course) {
        return <Typography variant="h6">Course Not Found</Typography>;
    }

    return (
        <>
            <Box
                sx={{
                    background: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url(${detailsPageBanner})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    py: { xs: 6, md: 10 },
                    px: { xs: 3, md: 5 },
                    color: "white",
                    textAlign: "left",
                }}
            >
                <Grid container spacing={4} alignItems="center">
                    {/* Left Section */}
                    <Grid item xs={12} md={7}>
                        <Typography variant="h4" fontWeight="bold">
                            {course.title}
                        </Typography>
                        <Box display="flex" alignItems="center" sx={{ mt: 1 }}>
                            <Typography sx={{ fontSize: "0.8rem", color: "gray" }}>
                                Ratings
                            </Typography>
                            <Rating value={course.rating} sx={{ ml: 1, fontSize: "1rem" }} readOnly precision={0.1} />
                            <Typography sx={{ ml: 1, fontSize: "0.8rem", color: "gray" }}>
                                ({course.reviews}+)
                            </Typography>
                        </Box>

                        <Box
                            sx={{
                                backgroundColor: "#ffc107",
                                display: "inline-block",
                                padding: "8px 16px",
                                fontWeight: "bold",
                                borderRadius: "5px",
                                mt: 2,
                            }}
                        >
                            UPDATE: NEW BATCH STARTING SOON
                        </Box>

                        <Typography variant="body1" sx={{ mt: 2, color: "#ccc", lineHeight: 1.5 }}>
                            {course.description}
                        </Typography>

                        {/* Buttons */}
                        <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
                            <Button
                                variant="contained"
                                //onClick={() => navigate("/enroll")}
                                sx={{
                                    background: "linear-gradient(135deg, #007bff, #0056b3)",
                                    fontWeight: "bold",
                                    padding: "12px 24px",
                                    borderRadius: "8px",
                                    "&:hover": { background: "#0056b3", transform: "scale(1.05)" },
                                }}
                            >
                                Enroll Now
                            </Button>
                            <Button
                                variant="contained"
                                sx={{
                                    background: "linear-gradient(135deg, #28a745, #218838)",
                                    fontWeight: "bold",
                                    padding: "12px 24px",
                                    borderRadius: "8px",
                                    "&:hover": { background: "#218838", transform: "scale(1.05)" },
                                }}
                            >
                                Download Syllabus
                            </Button>
                        </Box>
                    </Grid>

                    {/* Right Section - Inquiry Form */}
                    <Grid item xs={12} md={5}>
                        <Paper
                            elevation={6}
                            sx={{
                                padding: "24px",
                                background: "rgba(255, 255, 255, 0.95)",
                                borderRadius: "10px",
                            }}
                        >
                            <Typography variant="h6" fontWeight="bold" sx={{ color: "#333", textAlign: "center" }}>
                                Get More Info, Enquire Now!
                            </Typography>
                            <TextField fullWidth label="Full Name" variant="outlined" sx={{ mt: 2 }} />
                            <TextField fullWidth label="Phone/Mobile Number" variant="outlined" sx={{ mt: 2 }} />
                            <TextField fullWidth label="Email Address" variant="outlined" sx={{ mt: 2 }} />
                            <Button
                                variant="contained"
                                fullWidth
                                sx={{
                                    mt: 3,
                                    background: "#dc3545",
                                    color: "white",
                                    fontWeight: "bold",
                                    padding: "12px",
                                    "&:hover": { background: "#c82333" },
                                }}
                            >
                                Enquire Now
                            </Button>
                        </Paper>
                    </Grid>
                </Grid>
            </Box>

            <StudentsHiredBySection />
            <CourseCurriculumDetails curriculumData={course.curriculum} title={course?.title} fees={course?.fees} batch={course?.batch} />
        </>
    );
};

export default CourseDetailsBanner;
